import { render } from "./ModalEncuestas.vue?vue&type=template&id=08352cb6"
import script from "./ModalEncuestas.vue?vue&type=script&lang=js"
export * from "./ModalEncuestas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__